export default "__VITE_ASSET__dcd05da2__"